import React from "react";
import { useModalLoyaltyConfirmHook } from "./modal-loyalty-confirm-hooks";

type ContextModalLoyaltyConfirm = ReturnType<typeof useModalLoyaltyConfirmHook>;
export const ModalLoyaltyConfirmContext =
  React.createContext<ContextModalLoyaltyConfirm | null>(null);

export function useContextModalLoyaltyConfirm() {
  const context = React.useContext(ModalLoyaltyConfirmContext);

  if (!context) {
    throw new Error(
      "useContextModalLoyaltyConfirm must be used within a ContextModalLoyaltyConfirmProvider",
    );
  }

  return context;
}
